import { Component } from '@angular/core';

@Component({
  selector: 'app-code-of-conduct',
  templateUrl: './code-of-conduct.component.html',
  styleUrls: ['./code-of-conduct.component.scss'],
  standalone: false
})
export class CodeOfConductComponent {}
